<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :plugins="plugins"
    :css-classes="cssClasses"
    :styles="styles"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Bar } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
);

export default {
  name: "BarChart",
  components: {
    Bar,
  },
  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    data_golongan: [],

    chartData: {
      labels: [],

      datasets: [],
    },

    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,
    },
  }),

  async mounted() {
    this.jmlgolongan();
  },

  methods: {
    jmlgolongan() {
      const url = process.env.VUE_APP_ASN + "statistik/jumlah/golongan";

      this.http
        .get(url)
        .then((response) => {
          this.data_golongan = response.data.data;

          const nama_label = Object.keys(this.data_golongan[0]).filter((key) =>
            key.startsWith("golongan_"),
          );

          const labelReadable = nama_label.map((l) =>
            l.replace("golongan_", "Gol. "),
          );

          const series = this.data_golongan.map((item) => ({
            label: item.jenis_kelamin ?? "Tidak diketahui",
            backgroundColor:  item.jenis_kelamin == 'Laki-laki' ? "#2196F3" : "#E91E63",
            data: nama_label.map((g) => item[g]),
          }));

          this.chartData.labels = labelReadable;
          this.chartData.datasets = series;
        })
        .catch((error) => {
          console.log(error.response.status);
          console.log("Error", error.message);
        });
    },
  },
};
</script>
